/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFHoneypots } from './CRSFHoneypots';
import {
    CRSFHoneypotsFromJSON,
    CRSFHoneypotsFromJSONTyped,
    CRSFHoneypotsToJSON,
} from './CRSFHoneypots';

/**
 * 
 * @export
 * @interface CRSFHoneypotsPagedResponse
 */
export interface CRSFHoneypotsPagedResponse {
    /**
     * 
     * @type {number}
     * @memberof CRSFHoneypotsPagedResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFHoneypotsPagedResponse
     */
    page_size?: number;
    /**
     * 
     * @type {Array<CRSFHoneypots>}
     * @memberof CRSFHoneypotsPagedResponse
     */
    results?: Array<CRSFHoneypots>;
    /**
     * 
     * @type {number}
     * @memberof CRSFHoneypotsPagedResponse
     */
    total?: number;
}

/**
 * Check if a given object implements the CRSFHoneypotsPagedResponse interface.
 */
export function instanceOfCRSFHoneypotsPagedResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CRSFHoneypotsPagedResponseFromJSON(json: any): CRSFHoneypotsPagedResponse {
    return CRSFHoneypotsPagedResponseFromJSONTyped(json, false);
}

export function CRSFHoneypotsPagedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFHoneypotsPagedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(CRSFHoneypotsFromJSON)),
        'total': !exists(json, 'total') ? undefined : json['total'],
    };
}

export function CRSFHoneypotsPagedResponseToJSON(value?: CRSFHoneypotsPagedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(CRSFHoneypotsToJSON)),
        'total': value.total,
    };
}

